import { render, staticRenderFns } from "./RedirectByLinkWrapper.vue?vue&type=template&id=f4119da8&scoped=true&"
import script from "./RedirectByLinkWrapper.vue?vue&type=script&lang=js&"
export * from "./RedirectByLinkWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RedirectByLinkWrapper.vue?vue&type=style&index=0&id=f4119da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4119da8",
  null
  
)

export default component.exports